<template>
    <section class="col-12">
        <div class="d-flex">
            <div class="col">
                <label style="color: rgb(208, 49, 49) !important;"><strong>Current Year</strong></label>
                <select @change="getByYear()" v-model="selectedYear" class="form-control" style="font-size: 16px; font-weight: bolder; color: rgb(208, 49, 49) !important; width: 200px;">
                    <option style="color: rgb(208, 49, 49) !important;" v-for="year in years(2005, initalYear+10)" :value="year">{{ year }}</option>
                </select>
            </div>
            <div class="col">
                <div class="mt-3">
                    <label><strong>&nbsp;</strong></label>
                    <button type="button" @click.prevent="clearCopy" data-toggle="modal"
                            data-target="#modal-frequency-copy" class="btn btn-info">Copy
                    </button>
                </div>

                <!-- Modal -->
                <div class="modal fade" id="modal-frequency-copy" tabindex="-1" role="dialog"
                     aria-labelledby="modal-frequency-copy-label" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="modal-frequency-copy-label">Copy Frequency</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <label><strong>From Year</strong></label>
                                <select @change="getByYearDefault(true)" v-model="selectedYearCopy"
                                        class="form-control">
                                    <option value="">-</option>
                                    <option v-for="year in years(2005, initalYear+10)" :value="year">{{ year }}</option>
                                </select>
                                <br>
                                <table class="table table-responsive table-striped table-bordered d-table">
                                    <thead>
                                    <tr>
                                        <td style="width:15%">Type of Inspection</td>
                                        <td>Month</td>
                                        <td style="width:10%">Year</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, itemIndex) in itemsCopy">
                                        <td>
                                            <select v-model="item.period_id" disabled readonly
                                                    class="form-control">
                                                <option v-for="period in periods" :value="period.id">{{
                                                        period.name
                                                    }}
                                                </option>
                                            </select>
                                        </td>
                                        <td>
                                            <select v-model="item.month" disabled readonly
                                                    class="form-control">
                                                <option v-for="(month, index) in monthNames" :value="index+1">{{
                                                        month
                                                    }}
                                                </option>
                                            </select>
                                        </td>
                                        <td>
                                            <input readonly v-model="item.year" disabled
                                                   class="form-control">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="clearCopy" data-dismiss="modal">
                                    Cancel
                                </button>
                                <button v-if="idsCopy.length > 0" type="button" @click="saveCopy"
                                        class="btn btn-primary">Copy
                                </button>
                                <button v-else type="button" class="btn btn-primary disabled">Ckeck frequencies</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <br>
        <div class="table table-responsive">
            <table class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td style="width:5%" title="Is Default">D</td>
                    <td style="width:15%">Type of Inspection</td>
                    <td>Month</td>
                    <td style="width:10%">Year</td>
                    <td>Amount</td>
                    <td style="width:10%">Quantity Techs</td>
                    <td>Quantity Hours</td>
                    <td style="width:8%">Labor Rate</td>
                    <td>Service Ticket</td>
                    <td>E-mail Date</td>
                    <td v-if="!readOnly">Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in items.filter((e) => !e.hasOwnProperty('deleted'))">
                    <td>
                        <input type="checkbox" v-model="item.is_default">
                    </td>
                    <td>
                        <select :name="'inspectionFrequency['+itemIndex+'][period_id]'" v-model="item.period_id"
                                class="form-control">
                            <option v-for="period in periods" :value="period.id">{{ period.name }}</option>
                        </select>
                    </td>
                    <td>
                        <select :name="'inspectionFrequency['+itemIndex+'][month]'" v-model="item.month"
                                class="form-control">
                            <option v-for="(month, index) in monthNames" :value="index+1">{{ month }}</option>
                        </select>
                    </td>
                    <td>
                        <input readonly :name="'inspectionFrequency['+itemIndex+'][year]'" v-model="item.year"
                               class="form-control">
                    </td>
                    <td>
                        <input :name="'inspectionFrequency['+itemIndex+'][amount]'"
                               @change="checkValues(itemIndex,'amount')"
                               v-model="item.amount"
                               class="form-control">
                    </td>
                    <td>
                        <input :name="'inspectionFrequency['+itemIndex+'][quantity_techs]'"
                               @change="checkValues(itemIndex,'quantity_techs')"
                               v-model="item.quantity_techs" type="number" class="form-control">
                    </td>
                    <td>
                        <input :name="'inspectionFrequency['+itemIndex+'][quantity_hours]'"
                               @change="checkValues(itemIndex,'quantity_hours')"
                               v-model="item.quantity_hours" type="number" class="form-control">
                    </td>

                    <td>
                        <select :name="'inspectionFrequency['+itemIndex+'][labor_rate_id]'" v-model="item.labor_rate_id"
                                @change="checkValues(itemIndex,'labor_rate_id')"
                                class="form-control">
                            <option v-for="laborRate in laborRates" :value="laborRate.id">{{ laborRate.name }}</option>
                        </select>
                    </td>
                    <td>
                        <input :name="'inspectionFrequency['+itemIndex+'][service_ticket]'"
                               @change="checkValues(itemIndex,'service_ticket')"
                               v-model="item.service_ticket" type="text" class="form-control">
                    </td>
                    <td>
                        <input style="color: red !important;" v-if="item.approved" :name="'inspectionFrequency['+itemIndex+'][approved]'"
                               v-model="item.approved" type="date" class="form-control">
                        <a v-else @click.prevent.stop="setApproved(itemIndex)" href="#" title="Click to set date">Set
                            Date</a>
                    </td>
                    <td v-if="!readOnly"><a @click="deleteLine(item.id, itemIndex)" title="Delete"
                                            class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
                </tbody>
                <tfoot>
                <tr v-if="!readOnly">
                    <th colspan="10">
                        <button @click="showModal()" type="button"
                                class="btn btn-success"
                                data-toggle="tooltip"
                                data-original-title="Add more lines">
                            <i class="glyphicon glyphicon-plus-sign"></i>
                            Add
                        </button>

                    </th>

                </tr>
                </tfoot>
            </table>
            <modal-default size="sm" active-back-drop ref="addModal" show-footer title="Add Type of Inspection">
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="quantity">Type of Inspection</label>
                        <select v-model="form.index"
                                class="form-control">
                            <option v-for="(period, index) in periods" :value="index">{{ period.name }}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-12">
                        <label for="quantity">Quantity</label>
                        <select v-model="form.quantity"
                                class="form-control">
                            <option v-for="n in periods[form.index].quantity_months" :value="n">{{ n }}</option>
                        </select>
                    </div>
                </div>
                <template v-slot:actions>
                    <button type="button" class="btn btn-primary text-xs font-weight-bold mt-2"
                            @click="addLineValues().then((r) => {})">Create Type of Inspection
                    </button>
                </template>
            </modal-default>
        </div>
    </section>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import InspectionFrequencyComponent from "../../../models/InspectionFrequencyComponent";
import _ from "lodash";
import ModalDefault from "../../generics/ModalDefault.vue";
import index from "vuex";

export default {
    name: "InspectionFrequencyComponent",
    computed: {
        index() {
            return index
        }
    },
    components: {ModalDefault},
    props: {
        site: {
            type: Object,
            required: false,
            default: null
        },
        periods: {
            type: Array,
            required: true
        },
        laborRates: {
            type: Array,
            required: true
        },
        siteInspectionFrequencies: {
            type: Array,
            required: false
        },
        url: {
            type: String,
            required: false
        },
        urlGet: {
            type: String,
            required: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }

    },
    data: function () {
        return {
            items: [],
            itemsCopy: [],
            collection: [],
            monthNames: [],
            saveAsNew: false,
            initalYear: new Date().getFullYear(),
            selectedYear: new Date().getFullYear(),
            selectedYearCopy: null,
            idsCopy: [],
            form: {
                index: 0,
                period: {},
                quantity: 1,
            },
            deleteds: []
        }
    },
    mounted() {
        this.monthNames = monthNames
        if (!this.readOnly) {
            this.getByYear()
        }
    },
    watch: {
        selectedYear(val) {
            this.$store.commit('generic/setCurrentYear', val)
        },
        '$store.state.generic.currentYear'(val) {
            if (val !== this.selectedYear) {
                this.selectedYear = parseInt(val)
                this.getByYear()
            } else {
                this.setCurrentYear()
            }

        }
    },
    methods: {
        setCurrentYear() {
            axios.post('/current-year', {
                current_year: this.selectedYear
            })
        },
        setApproved(index) {
            this.items[index].approved = new Date()
        },
        showModal() {
            this.form.period = this.periods[0];
            this.$refs.addModal.show();
        },
        addLineValues() {
            let period = this.periods[this.form.index];
            for (let i = 0; i < this.form.quantity; i++) {
                let element = this.addLine();
                element.period_id = period.id
                this.items.push(element);
            }
            this.$refs.addModal.hide();
        },
        addLine(autoAdd = false) {
            let item = new InspectionFrequencyComponent()
            item.year = this.selectedYear
            if (autoAdd) {
                this.items.push(item);
            }
            return item;
        },
        checkValues(index, field) {
            for (let i = 0; i < this.items.length; i++) {
                if (i <= index) continue;
                if (this.items[i][field] === null || this.items[i][field] === "") {
                    this.items[i][field] = this.items[index][field];
                }
            }
        },
        deleteLine(id, itemIndex) {
            if (id) {
                let app = this;
                this.items[itemIndex]['deleted'] = true;
                this.deleteds.push(this.items[itemIndex])
                this.items.splice(itemIndex, 1);
                this.$forceUpdate()
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        years: years,

        onSave($form = null) {
            this.$loading(true);
            let app = this;
            for (let i = 0; i < this.deleteds.length ; i++) {
                this.items.push(this.deleteds[i]);
            }
            axios.post(this.url, {"year": this.selectedYear, "items": this.items, "saveAsNew": this.saveAsNew})
                .then((response) => {
                    this.$loading(false);
                    let result =  response.data.data;
                    app.getByYear()
                    if (result.hasOwnProperty('modified')){
                        $('#inspection_frequency_modified').val(JSON.stringify(result.modified))
                    }else{
                        $('#inspection_frequency_data').val(JSON.stringify(result))
                    }
                    if ($form) {
                       $form.submit();
                    }
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })

        },
        async getByYear(copy = false) {
            this.$loading(true);
            let rota = this.urlGet.replace(':year', copy ? this.selectedYearCopy : this.selectedYear)
            let app = this;
            await axios.get(rota)
                .then((response) => {
                    this.$loading(false);
                    if (copy) {
                        app.itemsCopy = response.data.data
                    } else {
                        app.items = response.data.data
                    }
                    app.$forceUpdate()
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })

        },

        async getByYearDefault() {
            this.$loading(true);
            let rota = this.urlGet.replace(':year', this.selectedYearCopy)
            let app = this;
            await axios.get(rota + '/default')
                .then((response) => {
                    this.$loading(false);
                    app.itemsCopy = response.data.data
                    app.idsCopy = app.itemsCopy.map(e => e.id)
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })

        },
        clearCopy() {
            this.itemsCopy = []
            this.selectedYearCopy = this.selectedYear - 1
            this.idsCopy = [];
            this.getByYearDefault()
        },

        saveCopy() {
            this.$loading(true);
            let app = this;
            axios.post(`/api/sites/inspection-frequency/${app.site.id}/copy`, {
                "year": this.selectedYear,
                "items": this.idsCopy
            })
                .then((response) => {
                    this.$loading(false);
                    app.getByYear()
                    $('#modal-frequency-copy').modal('hide')
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })

        },
    }
}
</script>

<style scoped>

</style>
